import type { EquipamentoResumo } from '../services/siCloudFunctionsService';
import type { TipoEquipamentoMovimentacao } from '../models';
import {
  TIPO_EQUIPAMENTO_LABELS,
  TIPOS_EQUIPAMENTO_SEM_SO,
  type SistemaOperacionalPrincipal,
} from '../pages/SolicitacaoDetailsPage/solicitacaoDetailsPage.definitions';

/** 1 item de intake por equipamento escolhido pra devolver, com o tipo já derivado de cada um
 * (Nova Solicitação e Nova Movimentação de devolução — o equipamento vem da lista, sem
 * perguntar tipo/SO de novo). */
export function itensIntakePorEquipamentos(equipamentos: EquipamentoResumo[]) {
  return equipamentos.map((equipamento) => ({
    id: crypto.randomUUID(),
    tipoEquipamento:
      equipamento.tipo && equipamento.tipo in TIPO_EQUIPAMENTO_LABELS
        ? (equipamento.tipo as TipoEquipamentoMovimentacao)
        : null,
    sistemaOperacional: null,
    homologado: null,
    propriedadeEquipamento: null,
    equipamentoSugeridoId: equipamento.id,
  }));
}

/** Item de devolução descrito à mão (não está entre os cadastrados) — o SI cadastra depois. */
export function itemOutroEquipamentoDevolucao(descricao: string) {
  const texto = descricao.trim();
  return texto
    ? [
        {
          id: crypto.randomUUID(),
          tipoEquipamento: null,
          sistemaOperacional: null,
          homologado: null,
          propriedadeEquipamento: null,
          equipamentoSugeridoId: null,
          descricaoLivre: texto,
        },
      ]
    : [];
}

const TIPOS_MAC = ['macbook', 'imac', 'macmini'];

/** SO "principal" do formulário a partir do cadastro do Inventário (texto livre, ex. "Windows
 * 11 Pro", vindo do GLPI) — null quando não dá pra saber sem chutar. */
function soDoEquipamento(equipamento: EquipamentoResumo): { soPrincipal: SistemaOperacionalPrincipal | 'sem_so'; tipoSemSo: TipoEquipamentoMovimentacao | '' } | null {
  const tipo = equipamento.tipo ?? '';
  if (TIPOS_EQUIPAMENTO_SEM_SO.includes(tipo as TipoEquipamentoMovimentacao)) {
    return { soPrincipal: 'sem_so', tipoSemSo: tipo as TipoEquipamentoMovimentacao };
  }
  if (TIPOS_MAC.includes(tipo)) return { soPrincipal: 'macos', tipoSemSo: '' };
  const so = (equipamento.sistemaOperacional ?? '').toLowerCase();
  if (so.includes('windows')) return { soPrincipal: 'windows', tipoSemSo: '' };
  if (so.includes('mac') || so.includes('os x')) return { soPrincipal: 'macos', tipoSemSo: '' };
  if (so.includes('android')) return { soPrincipal: 'android', tipoSemSo: '' };
  if (so.includes('ios') || so.includes('iphone')) return { soPrincipal: 'ios', tipoSemSo: '' };
  return null;
}

/**
 * Troca/Mudança de Projeto: o equipamento novo quase sempre tem o mesmo SO do que volta — o
 * formulário já sugere. Só quando todos os escolhidos apontam pro mesmo; senão não sugere.
 */
export function sugestaoSoParaTroca(
  equipamentos: EquipamentoResumo[]
): { soPrincipal: SistemaOperacionalPrincipal | 'sem_so'; tipoSemSo: TipoEquipamentoMovimentacao | '' } | null {
  const sugestoes = equipamentos.map(soDoEquipamento);
  if (sugestoes.length === 0 || sugestoes.some((s) => s == null)) return null;
  const [primeira] = sugestoes;
  return sugestoes.every((s) => s!.soPrincipal === primeira!.soPrincipal && s!.tipoSemSo === primeira!.tipoSemSo)
    ? primeira
    : null;
}
